import { render, staticRenderFns } from "./XingLogo.vue?vue&type=template&id=f5d53e86&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d53e86",
  null
  
)

export default component.exports